/*
 * @Author: ç¯çç§æ(Lucas Huang)
 * @Date: 2019-08-06 08:31:57
 * @LastEditors: ç¯çç§æ(Lucas Huang)
 * @LastEditTime: 2019-08-15 16:06:58
 * @QQ: 1055818239
 * @Version: v0.0.1
 */
import {
    Component, OnInit, Input, ViewChild, Renderer2,
    ElementRef, Output, EventEmitter, TemplateRef,
    AfterViewInit, SimpleChanges, OnChanges, OnDestroy, RendererStyleFlags2
} from '@angular/core';

import { fromEvent, Observable, Subscription } from 'rxjs';

import { AngularDraggableDirective } from '@farris/ui-draggable';
import { ModalDirective } from '@farris/ui-modal';
import { ContentChild } from '@angular/core';
import { debounceTime} from 'rxjs/operators';

@Component({
    selector: 'farris-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

    /** çªå£æ é¢ */
    @Input() title = 'ææ¯æ é¢';

    /** æ é¢å¾æ  */
    @Input() iconCls: string = undefined;

    /** å®½åº¦ */
    @Input() width = 300;
    /** é«åº¦ */
    @Input() height = 200;

    @Input() minWidth = 100;

    @Input() minHeight = 100;

    @Input() maxWidth: number = null;
    @Input() maxHeight: number = null;

    /** æ¾ç¤ºåºé¨æé®åºåï¼é»è®¤æ¾ç¤º */
    @Input() showButtons = true;
    /** æ¾ç¤ºå³ä¸è§å³é­æé®ï¼é»è®¤æ¾ç¤º */
    @Input() showCloseButton = true;
    /** æ¾ç¤ºæå¤§åæé®ï¼é»è®¤æ¾ç¤º */
    @Input() showMaxButton = true;
    /** æ¾ç¤ºæå°åæé®ï¼é»è®¤ä¸æ¾ç¤º, æ¾ç¤ºåºæ¥ä¹æ²¡æç¨ */
    @Input() showMinButton = false;

    /** å¯ç¨ææ½æ¹åå°ºå¯¸å¤§å° */
    @Input() resizable = true;
    /** å¯ç¨æå¨çªå£ */
    @Input() draggable = true;

    /** æé®å¯¹é½æ¹å¼ */
    @Input() buttonAlign = 'center';
    @Input() scrollConfig = {};

    @Input() beforeOpen: () => Observable<any> | Promise<any> | boolean;
    @Input() beforeClose: () => Observable<any> | Promise<any> | boolean;

    @ViewChild(ModalDirective) modal: ModalDirective;
    @ViewChild(AngularDraggableDirective) draggbar: AngularDraggableDirective;
    

    @Output() opened = new EventEmitter();
    @Output() closed = new EventEmitter();
    @Output() resized = new EventEmitter();
    @Output() resizing = new EventEmitter();
    @Output() maxed = new EventEmitter();
    @Output() widthChange = new EventEmitter();
    @Output() heightChange = new EventEmitter();
    @Output() moving =new EventEmitter();

    @Input() enableScroll = true;

    @Input() buttons: TemplateRef<any>;

    /** æ é¢æ é«åº¦ */
    @Input() dialogHeaderHeight = 0;

    /** æé®åºé«åº¦ */
    @Input() dialogFooterHeight = 0;


    @Input() parentElement = null;
    /** æ¾ç¤ºå¤´é¨ */
    @Input() showHeader = true;
    /** Html Element */
    @Input() dragHandle;

    /* template */
    @ContentChild('toolTemplate') toolTemplate: TemplateRef<any>;
    isMax = false; // æ¯å¦æå¤§çªå£
    dlgHeaderLineHeight: any;
    dlgFooterLineHeight: any;

    private originalWidth: number;  // è®°å½åå§çå®½åº¦
    private originalHeight: number; // è®°å½åå§çé«åº¦

    private prevWidth: number; // è®°å½ä¸æ¬¡çå®½åº¦
    private prevHeight: number; // è®°å½ä¸æ¬¡çé«åº¦

    private hostId = '';
    @ViewChild('modalContent') modalContent: ElementRef;
    @ViewChild('header') modalHeader: ElementRef;
    @ViewChild('dialogEl') dialogEl: ElementRef;
    /** çªå£æå¤§åæ¶ï¼æ¯å¦ä¸æµè§å¨ä¹é´æé´è·ï¼å½ä¸ºtrueæ¶ä¸æµè§å¨è¾¹è·ä¸º 0 */
    @Input() maxPadding = true;

    private windowResize$: Subscription = null;

    postitionStyles: any = {};

    get size() {
        const headerHeight = this.getDialogHeaderLineHeight();
        const footerHeight = this.getDialogFooterHeight();

        let contentHeight = this.height - headerHeight;
        if (this.showButtons) {
            contentHeight = contentHeight - footerHeight;
        }
        return {
            width: this.width,
            height: this.height,
            contentHeight,
            contentWidth: this.width,
            header: headerHeight,
            footer: footerHeight
        };
    }

    private _windowResizeToMax = false;


    private _mutationObserver = null;
    private _dialogEl = null;
    private footerEl = null;

    constructor(private render2: Renderer2, public el: ElementRef) { 

    }

    ngOnInit() {
        this.hostId = `farris-dialog_${new Date().getTime()}`;
        this.render2.setProperty(this.el.nativeElement, 'id', this.hostId);
        if (!this.beforeOpen) {
            this.beforeOpen = () => true;
        }

        if (!this.beforeClose) {
            this.beforeClose = () => true;
        }

        this.modal.onShown.subscribe(() => {
            this.opened.emit();
        });

        this.modal.onHidden.subscribe(() => this.closed.emit());

        this.checkDialogSize();
        setTimeout(() => {
            if (this.parentElement) {
                this.parentElement.appendChild(this.el.nativeElement);
            } else {
                document.body.appendChild(this.el.nativeElement);
            }

            if (this.showHeader && this.modalHeader) {
                this.dragHandle = this.modalHeader.nativeElement;
            }

        }, 100);
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    ngOnDestroy() {
        setTimeout(() => {
            this.destroy();
            this.el = null;
            if (this.parentElement) {
                this.parentElement = null;
            }

            if (this._mutationObserver) {
                // åæ­¢è§å¯å±æ§åå
                this._mutationObserver.disconnect();
                this._mutationObserver = null;
            }
        }, 150);
    }

    private getScreenSize() {
        const margin =  (this.maxPadding ? 20: 0);
        return {
            width: window.innerWidth - margin,
            height: window.innerHeight - margin,
            padding: margin? 10: 0
        }
    }

    ngAfterViewInit() {
        if (!this.dialogEl) {
            this._dialogEl = this.el.nativeElement.querySelector('.modal-dialog');
        } else {
            this._dialogEl = this.dialogEl.nativeElement;
        }

        this.dlgHeaderLineHeight = this.getDialogHeaderLineHeight();

        if (this.dialogHeaderHeight && this.modalHeader) {
            this.modalHeader.nativeElement.style.height = `${this.dialogHeaderHeight}px`;
        }

        if (this.dialogFooterHeight) {
            const footer = this.modalContent.nativeElement.querySelector('.modal-footer');
            if (footer) {
                footer.style.height = `${this.dialogFooterHeight}px`;
            }
        }

        this.originalHeight = this.height;
        this.originalWidth = this.width;

        this.resetPosition();

        this.windowResize$ = fromEvent(window, 'resize').pipe(
            debounceTime(50)
        ).subscribe((e: any) => {

            const { width: winWidth, height: winHeight } = this.getScreenSize();

            if (this.width <= winWidth && this.height <= winHeight) {
                if (this._windowResizeToMax) {
                    this.revertDialog();
                    this._windowResizeToMax = false;
                } else {
                    if(this.isMax) {
                        this.maxDialog(false);
                    }
                }
            } else {
                if (!this.isMax) {
                    this._windowResizeToMax = true;
                    this.maxDialog();
                } else {
                    this.maxDialog(false);
                }
            }

            this.toCenter(0, 0);
        });

       
        // this.listenattributesChanged();
    }

    // private listenattributesChanged() {
    //      // è§å¯å¨çéç½®ï¼éè¦è§å¯ä»ä¹åå¨ï¼
    //      const config = { attributes: true, subtree: false,characterData:true, attributeFilter: ['style'], attributeOldValue: true} ;

    //      // å½è§å¯å°åå¨æ¶æ§è¡çåè°å½æ°
    //      const callback = (mutationsList, observer) => {
    //         // Use traditional 'for loops' for IE 11
    //         for(let mutation of mutationsList) {
    //             // console.log(mutation);

    //         }
    //      };
 
    //      // åå»ºä¸ä¸ªè§å¯å¨å®ä¾å¹¶ä¼ å¥åè°å½æ°
    //      this._mutationObserver = new MutationObserver(callback);
 
    //      // ä»¥ä¸è¿°éç½®å¼å§è§å¯ç®æ èç¹
    //      this._mutationObserver.observe(this.dialogEl.nativeElement, config);
    // }

    toCenter(x: number, y: number) {
        this.resetPosition();
        this.draggbar.position = { x, y };
        this.draggbar.resetPosition();
    }

    destroy() {
        if (!this.parentElement) {
            if (document.body.querySelector(`#${this.hostId}`)) {
                document.body.removeChild(this.el.nativeElement);
            }
        } else {
            if (this.parentElement.querySelector(`#${this.hostId}`)) {
                this.parentElement.removeChild(this.el.nativeElement);
            }
        }

        if (this.windowResize$) {
            this.windowResize$.unsubscribe();
            this.windowResize$ = null;
        }
    }

    private getDialogHeaderLineHeight() {
        if (this.modalHeader) {
            if (!this.dlgHeaderLineHeight) {
                this.dlgHeaderLineHeight = 0;
            }

            const hh = Math.ceil(this.modalHeader.nativeElement.getBoundingClientRect().height);
            this.dlgHeaderLineHeight = hh;
            return this.dlgHeaderLineHeight;
        }

        return 0;
    }

    private getDialogFooterHeight() {
        if (!this.footerEl) {
            const _footerEl =  this.modalContent.nativeElement.querySelector('.modal-footer');
            this.footerEl = _footerEl; 
        }
        if (!this.dlgFooterLineHeight) {
            this.dlgFooterLineHeight = 0;
        }

        if (this.footerEl) {
            this.footerEl.style.height = 'auto';
            const _fh = Math.ceil(this.footerEl.getBoundingClientRect().height);
            this.dlgFooterLineHeight = _fh;
        }

        return this.dlgFooterLineHeight;

        // const footerEl =  this.modalContent.nativeElement.querySelector('.modal-footer');
        // if (footerEl) {
        //     if (!this.dlgFooterLineHeight) {
        //         this.dlgFooterLineHeight = Math.ceil(footerEl.getBoundingClientRect().height);
        //     }

        //     return this.dlgFooterLineHeight;
        // }

        // return  0;
    }

    private _checkDialogSize(width: number, height: number) {

        // å¯è§åºåå°ºå¯¸
        const winSize = {
            width: document.body.offsetWidth,
            height: window.innerHeight
        };

        if (this.parentElement) {
            winSize.width = this.parentElement.offsetWidth;
            winSize.height = this.parentElement.offsetHeight;
        }

        if (winSize.width && winSize.width < width) {
            width = winSize.width;
        }

        if (winSize.height && winSize.height < height) {
            height = winSize.height;
        }

        return {
            width,
            height
        };
    }

    private checkDialogSize() {
        const newSize = this._checkDialogSize(this.width, this.height);
        if (this.width !== newSize.width) {
            this.width = newSize.width - 20;
            this.widthChange.emit(this.width);
        }

        if (this.height !== newSize.height) {
            this.height = newSize.height - 20;
            this.heightChange.emit(this.height);
        }
    }

    updateModalBodyHeight() {
        const contentEl = this.el.nativeElement.querySelector('.modal-body');
        const contentHeight = this.size.contentHeight;
        this.render2.setStyle(contentEl, 'height', contentHeight + 'px');
    }

    private updatePosition() {
        const marginLeft = Number.parseInt('' + -this.width / 2);
        const marginTop = Number.parseInt('' + -this.height / 2);
        
        this.postitionStyles = {
            marginLeft: marginLeft+ 'px',
            marginTop: marginTop+ 'px',
            transform: 'translate3d(0px, 0px, 0px)',
            top: `${window.innerHeight / 2 + marginTop}px`,
            left: `${window.innerWidth /2 + marginLeft}px`,
            top1: this.isMax? '10px': '50%',
            left1: this.isMax? '10px': '50%'
        };

        
    }

    resetPosition() {
        this.updatePosition();
        if (this._dialogEl) {
            const dialogEl = this._dialogEl;
            this.render2.setStyle(dialogEl, 'top', this.postitionStyles.top);
            this.render2.setStyle(dialogEl, 'left', this.postitionStyles.left);
            this.render2.setStyle(dialogEl, 'transform', this.postitionStyles.transform);
        }
    }

    private openDialog(flag: boolean) {
        if (flag) {
            this.resetPosition();
            this.draggbar.resetPosition();
            this.modal.show();

            // setTimeout(() => {
            //     const backdropEl = this.el.nativeElement.querySelector('.farris-modal');
            //     const modals = Array.from(document.body.querySelectorAll('.farris-modal.show')).filter((n: any) => (n.style.display !== 'none' && n !== backdropEl));
            //     if (modals && modals.length > 0) {
            //         const zIndexArr = modals.map(n => {
            //             return parseInt(window.getComputedStyle(n).getPropertyValue('z-index'), 10);
            //         }).filter(n => n);
            //         const maxZIndex = Math.max(...zIndexArr);
            //         backdropEl.style.zIndex = maxZIndex + 1;
            //     }
            // });
        }
    }

    private closeDialog(canClose: boolean) {
        if (canClose) {
            this.modal.hide();

            // this.closed.emit();
        }
    }

    show() {
        const result = this.beforeOpen();
        if (typeof result === 'boolean') {
            this.openDialog(result);
        } else {
            if (result instanceof Observable) {
                result.subscribe((flag: boolean) => {
                    this.openDialog(flag);
                });
            } else {
                if (result instanceof Promise) {
                    result.then((flag: boolean) => {
                        this.openDialog(flag);
                    });
                }
            }
        }
    }

    close($event?: MouseEvent) {
        if ($event) {
            $event.stopPropagation();
        }
        const result = this.beforeClose();
        if (typeof result === 'boolean') {
            this.closeDialog(result);
        } else {
            if (result instanceof Observable) {
                result.subscribe((flag: boolean) => {
                    this.closeDialog(flag);
                });
            } else {
                if (result instanceof Promise) {
                    result.then((flag: boolean) => {
                        this.closeDialog(flag);
                    });
                }
            }
        }
    }

    reSize(size: { width?: number, height?: number }) {
        if (size.width) {
            this.width = size.width;
        }
        if (size.height) {
            this.height = size.height;
        }

        this.resetPosition();
        this.draggbar.resetPosition();
        this.widthChange.emit(this.width);
        this.heightChange.emit(this.height);
        this.resized.emit({ size: { width: this.width, height: this.height } });
    }

    onResizing(opts: any) {

        opts.size.width = opts.size.width < 100 ? 100 : opts.size.width;
        opts.size.height = opts.size.height < 100 ? 100 : opts.size.height;

        this.width = opts.size.width;
        this.height = opts.size.height;
        this.resizing.emit(opts);
    }

    resizeStop(opts: any) {
        opts.size.width = opts.size.width < 100 ? 100 : opts.size.width;
        opts.size.height = opts.size.height < 100 ? 100 : opts.size.height;

        this.width = opts.size.width;
        this.height = opts.size.height;
        this.updateModalBodyHeight();

        this.widthChange.emit(this.width);
        this.heightChange.emit(this.height);

        this.resized.emit(opts);
    }

    dropdown(el: any) {
        // const rect = el.getBoundingClientRect();
        // this.render2.removeStyle(el, 'margin-top');
        // this.render2.removeStyle(el, 'margin-left');
        // this.render2.setStyle(el, 'top', `${rect.top}px`);
        // this.render2.setStyle(el, 'left', `${rect.left}px`);

        // this.render2.removeStyle(el, 'transform');
        // this.render2.removeStyle(el, '-webkit-transform');
        // this.render2.removeStyle(el, '-ms-transform');
        // this.render2.removeStyle(el, '-moz-transform');
        // this.render2.removeStyle(el, '-o-transform');
    }

    maxDialog(rememberPrevSize = true) {
        if (!this.el) {
            return;
        }
        if (rememberPrevSize) {
            this.prevWidth = this.width;
            this.prevHeight = this.height;
        }
        
        const { width: winWidth, height: winHeight, padding } = this.getScreenSize();
        this.width = winWidth;
        this.height = winHeight;


        this.draggable = false;
        this.resizable = false;
        

        this.isMax = true;
        this.toCenter(0, 0);

        const dialogEl = this.el.nativeElement.querySelector('.modal-dialog');

        this.render2.setStyle(dialogEl, 'top', padding);
        this.render2.setStyle(dialogEl, 'left', padding);


        this.resized.emit({ size: { width: this.width, height: this.height } });
        this.maxed.emit({ size: { width: this.width, height: this.height } });
    }

    revertDialog() {
        this.isMax = false;

        const { width: ww, height: wh } = this.getScreenSize();

        this.width = this.prevWidth == ww ? this.originalWidth : this.prevWidth;
        this.height = this.prevHeight == wh ? this.originalHeight : this.prevHeight;
       
        if (this.width > ww) {
            this.width = ww;
        }

        if (this.height > wh) {
            this.height = wh;
        }

        this.draggable = true;
        this.resizable = true;
        this.resetPosition();
        this.draggbar.resetPosition();
        this.resized.emit({ size: { width: this.width, height: this.height } });
        this.maxed.emit({ size: { width: this.width, height: this.height } });
    }

    changeDialogSize() {
        if (this.isMax) {
            this.revertDialog();
        } else {
            this.maxDialog();
        }
        this._windowResizeToMax = false;
    }

    onMoving($event) {
        this.moving.emit({ target: this.dialogEl.nativeElement , ...$event });
    }
}
